import { LinkProps } from "@mui/material"
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom"

import * as Styled from "./L2RLink.styled"

type L2RLinkProps = {
    className?: string
    children?: React.ReactNode
} & Omit<LinkProps, "href"> &
    RouterLinkProps

export const L2RLink = (props: L2RLinkProps) => {
    const {
        className,
        to,
        children,
        ...linkProps
    } = props

    return (
        <Styled.Link className={className} component={RouterLink} to={to} {...linkProps}>{children}</Styled.Link>
    )
}